export const GAME_FONTS = {
  HEADER: 'Rubik-SemiBold',
  REGULAR: 'Rubik',
  PIXEL: '"Press Start 2P"'
} as const

export const TEXT_STYLES = {
  HEADER: {
    fontFamily: GAME_FONTS.HEADER,
    fontSize: '24px',
    color: '#ffffff'
  },
  REGULAR: {
    fontFamily: GAME_FONTS.REGULAR,
    fontSize: '15px',
    color: '#84919E'
  },
  PIXEL: {
    fontFamily: GAME_FONTS.PIXEL,
    fontSize: '24px',
    color: '#000000'
  }
} as const

export class FontManager {
  static loadFonts(): Promise<void> {
    return new Promise((resolve, reject) => {
      document.fonts.ready.then(() => {
        const pixelFont = new FontFace('Press Start 2P', 'url("./assets/fonts/PressStart2P-Regular.ttf")')
        const rubikFont = new FontFace('Rubik', 'url("./assets/fonts/Rubik-Regular.ttf")')
        const rubikSemiBoldFont = new FontFace('Rubik-SemiBold', 'url("./assets/fonts/Rubik-SemiBold.ttf")')

        Promise.all([pixelFont.load(), rubikFont.load(), rubikSemiBoldFont.load()])
          .then(fonts => {
            fonts.forEach(font => (document.fonts as any).add(font))
            console.log('Fonts loaded successfully:', fonts.map(f => f.family))
            resolve()
          })
          .catch(err => {
            console.error('Font loading failed:', err)
            reject(err)
          })
      }).catch(err => {
        console.error('Document fonts not ready:', err)
        reject(err)
      })
    })
  }
}
